/**
 * Names of the autopilot workflow surface (see docs/autopilot-contract.md).
 *
 * Implemented by autopilot: the workflow type and task queue. NOT implemented yet: the query,
 * update and signal below (use Temporal's native cancel) and the search attributes (they are not
 * registered on the namespace, so ops-desk sets none unless explicitly enabled).
 */
export const ADHOC_SUBMISSION_WORKFLOW = 'AdhocSubmission';
export const TASK_QUEUE = 'submission-pilot';

export const QUERY_GET_STATUS = 'getStatus';
export const UPDATE_SUBMIT_DECISION = 'submitDecision';
export const SIGNAL_REQUEST_CANCEL = 'requestCancel';

/** Custom search attribute names and their Temporal types. */
export const SEARCH_ATTRIBUTES = {
  /** Keyword */
  requestId: 'OpsDeskRequestId',
  /** Keyword */
  quoteNumber: 'QuoteNumber',
  /** Bool */
  awaitingDecision: 'AwaitingDecision',
  /** Keyword */
  stage: 'AutopilotStage',
} as const;

export const SA_OPS_DESK_REQUEST_ID = SEARCH_ATTRIBUTES.requestId;
export const SA_QUOTE_NUMBER = SEARCH_ATTRIBUTES.quoteNumber;
export const SA_AWAITING_DECISION = SEARCH_ATTRIBUTES.awaitingDecision;
export const SA_AUTOPILOT_STAGE = SEARCH_ATTRIBUTES.stage;
